import PT from 'prop-types';
import React from 'react';

import { useIntl } from 'react-intl';
import PageLayout from '~/ui/components/PageLayout/PageLayout';
import Text from '~/ui/components/Text/Text';

const { SidebarSectionItem } = PageLayout;

function EmptySectionItem({ indent = 0, message = undefined, py = 0 }) {
  const intl = useIntl();
  const defaultMessage = intl.formatMessage({
    id: 'EmptySectionItem.noFieldsYet',
    defaultMessage: 'No fields yet',
    description: 'Message displayed when there are no fields in the section',
  });

  return (
    <SidebarSectionItem
      indent={indent}
      py={py}
      sx={{ height: 'sidebar-section-item-height' }}
    >
      <Text
        color="gray-600"
        pl={`${indent * 10}px`}
        sx={{ alignSelf: 'center' }}
        variant="xs-dense-medium"
      >
        {message ?? defaultMessage}
      </Text>
    </SidebarSectionItem>
  );
}

EmptySectionItem.propTypes = {
  indent: PT.number,
  message: PT.string,
};

export default EmptySectionItem;
